import { Component, computed, inject, OnDestroy, output, viewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ClientEntity, OrderEntity } from '@domain';
import { ClientSettupComponent } from 'src/app/modules/clients/pages/list/components/client-settup/client-settup.component';
import { RaModalComponent } from 'src/app/shared/components/ra-modal/ra-modal.component';
import { OrderDescriptionComponent } from './components/order-description/order-description.component';
import { OrderListClientsComponent } from './components/order-list-clients/order-list-clients.component';
import { OrderCreateService } from './services/order-create.service';

@Component({
    selector: 'order-create',
    templateUrl: 'order-create.component.html',
    styleUrl: 'order-create.component.scss',
    imports: [
        RaModalComponent,
        OrderDescriptionComponent,
        OrderListClientsComponent,
        ClientSettupComponent,
        TranslatePipe,
    ],
})
export class OrderCreateComponent implements OnDestroy {
    public close = output<void>();
    public created = output<OrderEntity>();

    private _listClients = viewChild(OrderListClientsComponent);

    /** Serviço sendo criado: o modal não fecha no meio da requisição. */
    public creating = computed(() => this._listClients()?.loadingCreate() ?? false);

    // * [Injects]
    public orderCreateService = inject(OrderCreateService);

    /**
     * Cliente cadastrado sem sair da criação do serviço: entra na lista já selecionado,
     * para o usuário só confirmar em "Criar serviço".
     */
    public onClientCreated(client: ClientEntity): void {
        this._listClients()?.addClient(client);
    }

    ngOnDestroy(): void {
        this.orderCreateService.clear();
    }
}
